import { Component } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-label',
  standalone: true,
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent {
  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;

  getControlLabel() {
    return this.group.get(this.field.name).value;
  }
}
